module.exports = __webpack_public_path__ + "static/img/img3.f4c66e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img3.jpg
// module id = 9Xiz
// module chunks = 0